import { useBreakpointDown } from 'epic-ue-theme';
import { useScroll, Image } from 'epic-ue-ui';
import { useTransform, motion, useMotionValue } from 'framer-motion';
import React from 'react';
import styled from 'styled-components';

const Styled = styled.div`
    .mask-container {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 100%;
        height: 100%;
        z-index: 7;
        text-align: center;
        .image-wrapper {
            position: absolute;
            margin-left: auto;
            margin-right: auto;
            right: 0;
            text-align: center;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
        }
    }
`;

interface MaskedHeaderIconProps {
    svg?: string;
}

export const MaskedHeaderIcon = ({svg}: MaskedHeaderIconProps):JSX.Element => {
    const {position} = useScroll();
    const scrollY = useMotionValue(0);
    scrollY.set(position.y);

    //increase the size of the Unreal icon
    const scaleSVG = useTransform(scrollY, [0, 500], [1, 3]);

    //fade out the Unreal icon
    const SVGOpacity = useTransform(scrollY, [0, 600], [0.95, 0]);

    const downSm = useBreakpointDown('sm');
    const downMd = useBreakpointDown('md');
    let svgSize = 330;

    if (downMd) {
        svgSize = 300;
    } else if (downSm) {
        svgSize = 250;
    }

    const svgLogo = svg || 'https://cdn2.unrealengine.com/new-ulogo-9f6a2cfee04a.svg';

    return (
        <Styled>
            <motion.div
                className="mask-container will-change-opacity-transform"
                style={{
                    scale: scaleSVG,
                    opacity: SVGOpacity
                }}>
                <Image
                    height={svgSize}
                    width={svgSize}
                    fit={'contain'}
                    src={svgLogo}
                    disableRatioHelper={true}
                />
            </motion.div>
        </Styled>
    );
}
